<template>
  <div class="template hover" @click.stop.prevent="handClick">
    <iconpark-icon name="edit" />
    <span class="ml-[4px]">{{ $t('chuang-zuo-tong-kuan') }}</span>
  </div>
</template>

<script lang="ts" setup>
import { useTemplate } from '~/features/template/components/info';

const props = defineProps<{ data: any }>();

const handClick = () => {
  useTemplate({ ...props.data, id: props.data?.model_id });
};
</script>

<style lang="scss" scoped>
.template {
  @apply absolute-center flex-center text-14 text-primary px-[11px] py-[6px] rounded-[8px] cursor-pointer;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(3px);
}
</style>
